import { LoginStateResponseState } from '@sbercloud/typings-iam-auth-client';
import { BASENAME } from '#constants/basename';
import { RoutePath } from '#constants/routes';
export const evaluateLoginMethods = (loginMethods, state) => {
  const {
    customerSso,
    passkey,
    password,
    identityProviders = [],
    ldap
  } = loginMethods ?? {};
  const isErrorPage = location.pathname === `${BASENAME}${RoutePath.ErrorPage}`;
  const hasPrimaryLoginMethod = Boolean(customerSso || passkey || password || ldap);
  const isAnyLoginMethodAvailable = hasPrimaryLoginMethod || identityProviders.length > 0;
  const isSingleIdentityProvider = identityProviders.length === 1 && !hasPrimaryLoginMethod;
  return {
    shouldShowLoginUnavailable: state === LoginStateResponseState.Login && !isAnyLoginMethodAvailable,
    shouldRedirectToSingleIdProvider: !window.location.pathname.includes(RoutePath.MagicLink) && !isErrorPage && isSingleIdentityProvider
  };
};